import { IIsiDtoFormValidateManagerSettings, IIsiDtoFormValidateManagerRules} from "../../Dtos/Isilog.IsiFramework.IsiDataTransferObject";

export class IsiFormValidateManager {

    _formValidate: IIsiDtoFormValidateManagerSettings;
    _rules: IIsiDtoFormValidateManagerRules[];

    constructor(formValidateManager : IIsiDtoFormValidateManagerSettings) {
        this._formValidate = formValidateManager;
        if (this._formValidate.rules) {
            this.initRules();
        }    
    }

    initRules() {
        this._rules = this._formValidate.rules;

        if (this._rules.length > 0) {
            this.valForm(this._formValidate.formId);
            this._rules.forEach(function (dtoRule) {
                let regexp = new RegExp(dtoRule.regexp)
                this.gvr(dtoRule.ctrlId, regexp, dtoRule.msgValidation)
            },this)
        }
    }

    gvr(inputId, regexp, message) {
        /// <summary>
        /// Génération des règles de validation pour les champs
        /// </summary>
        jQuery("#" + inputId).rules("add", {
            regex: regexp,
            messages: {
                regex: message
            }
        });
    }

    valForm(formId) {
        jQuery.validator.addMethod(
            "regex",
            function (value, element, regexp) {
                var check = false;
                var matches = regexp.exec(value);
                if (matches != null) {
                    check = this.optional(element) || true;
                } else {
                    check = this.optional(element) || false;
                }
                if (check) {
                    var elem = jQuery("#" + element.id + "-error", document.body);
                    if (elem.length > 0) {
                        elem.remove();
                    }
                }
                return check;
            },
            "Please check your input"
        );
        //si l'ecran est rwd on ne change pas la position de l'element
        if (jQuery(document.body).hasClass("rwd")) {
            jQuery("#" + formId).validate({
                errorClass: "validatorError",
                errorElement: "div",
                validClass: "validatorSuccess",
                onsubmit: false
            });
        } else {
            jQuery("#" + formId).validate({
                errorClass: "validatorError",
                errorElement: "div",
                errorPlacement: function (error, element) {
                    var elem = jQuery("#" + error.attr("id"), document.body);
                    if (elem.length > 0) {
                        elem.remove();
                    }
                    jQuery(document.body).append(error);
                    error.position({
                        of: element,
                        my: "left top",
                        at: "left bottom",
                        collision: "none none"
                    });
                    error.css("width", element.outerWidth());
                },
                validClass: "validatorSuccess",
                onsubmit: false
            });
        }

        var prm = window.Sys.WebForms.PageRequestManager.getInstance();
        prm.add_initializeRequest(function (me, formIdt) {
            return function (sender, args) {
                if (jQuery(".validator").length > 0) {
                    if (jQuery(".validator").valid() == false) {
                        args.set_cancel(true);
                    }
                }
            }(this, formId)
        });
    }
}